import { Component, OnInit } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";
import { ErrorService } from "../../../control-core/services/error.service";
import { CONTROL_APP_CONST } from "../../config/control-app.constant";
import { IOrdenPago } from "../../models/ser/ordenpago.model";
import { SimpleTableConfig } from "../../../control-core/shared/simple-table/simple-table.component";
import { FormControl, FormGroup } from "@angular/forms";
import { moneymask, SYMBOL_COP, SYMBOL_USD } from "../../../control-core/util/moneymask.util";
import { notify, SUCCESS_NOTIFY } from "../../../control-core/util/notify.util";
import { StateService } from '@uirouter/core';
import { initWaitMe, stopWaitMe } from "../../../control-core/util/waitme.util";
import { GeparametersService } from "../../../control-core/services/geparameters.service";
import { Subscription } from 'rxjs/Subscription';

declare let jquery: any;
declare let $: any;

@Component({
  selector: 'app-ordenpago',
  templateUrl: './ordenpago.component.html'
})
export class OrdenpagoComponent implements OnInit {

  consultaForm: FormGroup;
  configTablaOrdenesPago = new SimpleTableConfig();
  consultando: boolean = false;
  ordenPagoSeleccionado: string = '';
  convBaloto: string = '';
  cuentaOccidente: string = '';
  linkPSE: string = '';

  private _geparametersSubscription: Subscription = null;

  constructor(private _http: HttpClient,
              private _state: StateService,
              private _parameters: GeparametersService,
              private _translate: TranslateService,
              private _errorService: ErrorService) {
  }

  ngOnInit() {

    this._geparametersSubscription = this._parameters.state$.subscribe((estado) => {
      if (estado == 'ready') {
        this.convBaloto = this._parameters.getStrval('CTRBX_CONVENIO_BALOTO');
        this.cuentaOccidente = this._parameters.getStrval('CUENTA_BANCO_OCCIDENTE');

        this.linkPSE = this._parameters.getStrval('LINK_PAGO_PSE');
      }
    });

    let referencia = '';

    if (this._state.params.referencia != null && this._state.params.referencia != '') {
      referencia = this._state.params.referencia;
    }

    this.consultaForm = new FormGroup({
      numwhr: new FormControl(''),
      numordenpago: new FormControl(referencia)
    });

    let pagada = this._translate.instant('ORDEN_PAGADA_LABEL');
    let pendiente = this._translate.instant('ORDEN_PENDIENTE_LABEL');
    let porcomprobar = this._translate.instant('ORDEN_PORCOMPROBAR_LABEL');

    this.configTablaOrdenesPago.columns = [
      {label: 'REFERENCIA_LABEL', name: 'refinterna'},
      {label: 'NUM_WHR_LABEL', name: 'nrowhr'},
      {label: 'FECHA_VENCIMIENTO_LABEL', name: 'fechavencimiento'},
      {label: 'TOTAL_USD_LABEL', name: 'totaluss'},
      {label: 'TOTAL_COP_LABEL', name: 'totalcops'},
      {
        label: 'ESTADO_LABEL', name: 'pagada', options: {
          render: (data, index, row) => {
            if (row.pagada) {
              return '<span class="label label-success">' + pagada + '</span>';
            } else if (row.porcomprobar) {
              return '<span class="label label-warning">' + porcomprobar + '</span>';
            } else {
              return '<span class="label label-danger">' + pendiente + '</span>';
            }
          }
        }
      },
    ];

    this.configTablaOrdenesPago.optionColumns = [{
      label: 'DETALLE_LABEL', action: (row) => {
        this.ordenPagoSeleccionado = row.refinterna;
        $('#detallePagoModal').modal('show');
      }
    }];
    this.consulta();
  }

  consulta() {
    this.consultando = true;

    let dataRequest = this.consultaForm.value;

    initWaitMe('#tblResultadosOrden');

    this._http.get<IOrdenPago[]>(`${CONTROL_APP_CONST.API_URL}consultaOrdenPago`, {params: dataRequest})
        .map((response) => {
          response.forEach((valueRes) => {
            valueRes['totaluss'] = moneymask(valueRes.totalpago, SYMBOL_USD);
            valueRes['totalcops'] = moneymask(valueRes.totalpagocop, SYMBOL_COP);
          });
          return response;
        })
        .subscribe(
            (response) => {
              this.configTablaOrdenesPago.data = [];

              response.forEach((value) => {
                this.configTablaOrdenesPago.data.push(value);
              });
              this.consultando = false;
            }, (error) => {
              this._errorService.manejaError(error);
              this.consultando = false;
            }, () => {
              stopWaitMe('#tblResultadosOrden');
            }
        );
  }

  cerrarModal() {
    this.ordenPagoSeleccionado = '';
    $('#detallePagoModal').modal('hide');
  }

  modalInfoPago(response) {
    $('#comoPagoModal').modal('show');
  }

  onAnulado(response) {
    if (response.success) {
      this.cerrarModal();
      setTimeout(() => {
        notify(this._translate.instant(response.msg), SUCCESS_NOTIFY);
        this.consulta();
      }, 270);
    } else {
      this._errorService.manejaError(response.msg);
    }
  }

  onComprobado(response) {
    if (response.success) {
      this.cerrarModal();
      setTimeout(() => {
        notify(this._translate.instant(response.msg), SUCCESS_NOTIFY);
        this.consulta();
      }, 270);
    } else {
      this._errorService.manejaError(response.msg);
    }
  }

  goPerfil() {
    $('#comoPagoModal').modal('hide');
    setTimeout(() => {
      this._state.go("detallecliente", {}, {});
    }, 270);
  }

  ngOnDestroy() {
    this._geparametersSubscription.unsubscribe();
    $('.modal').modal('hide');
    $('.modal-backdrop').remove();
  }

}



// WEBPACK FOOTER //
// ./src/app/control-app/views/ordenpago/ordenpago.component.ts